import StarIcon from './component.jsx'

export default StarIcon
